import { render, staticRenderFns } from "./prop_panel.vue?vue&type=template&id=4616550f&scoped=true&lang=pug&"
import script from "./prop_panel.vue?vue&type=script&lang=js&"
export * from "./prop_panel.vue?vue&type=script&lang=js&"
import style0 from "./prop_panel.vue?vue&type=style&index=0&id=4616550f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4616550f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4616550f', component.options)
    } else {
      api.reload('4616550f', component.options)
    }
    module.hot.accept("./prop_panel.vue?vue&type=template&id=4616550f&scoped=true&lang=pug&", function () {
      api.rerender('4616550f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prop_panel/prop_panel.vue"
export default component.exports